import { StorageLocalBase } from "./StorageBase";
import {
  ApiSchemaLogin,
  ApiSchemaMenuBuilder,
} from "../../models/api/apiSchemaLogin";

class StorageAuthImpl extends StorageLocalBase {
  StorageNamespace = "auth";

  readonly TokenType = "Bearer";

  private readonly KeyToken: string = "token";
  private readonly KeyEmail: string = "email";
  private readonly KeyUserName: string = "userName";
  private readonly KeyUser: string = "user";
  private readonly KeyLeftNav: string = "menu";
  private readonly KeyRole: string = "role";

  get Token(): string | undefined {
    return this.getString(this.KeyToken);
  }

  set Token(token: string | undefined) {
    this.setString(this.KeyToken, token);
  }

  get AuthHeaderValue(): string | undefined {
    const headerVal = this.getString(this.KeyToken);
    return headerVal ? this.TokenType + " " + headerVal : undefined;
  }

  get Email(): string | undefined {
    return this.getString(this.KeyEmail);
  }

  set Email(token: string | undefined) {
    this.setString(this.KeyEmail, token);
  }

  get UserName(): string | undefined {
    return this.getString(this.KeyUserName);
  }

  set UserName(token: string | undefined) {
    this.setString(this.KeyUserName, token);
  }

  get User(): ApiSchemaLogin | undefined {
    return JSON.parse(this.getString(this.KeyUser) || "");
  }

  set User(user: ApiSchemaLogin | undefined) {
    this.setString(this.KeyUser, JSON.stringify(user));
  }

  get Menu(): ApiSchemaMenuBuilder | undefined {
    return this.getObject(this.KeyLeftNav);
  }

  set Menu(token: ApiSchemaMenuBuilder | undefined) {
    this.setObject(this.KeyLeftNav, token);
  }

  get Role(): string | undefined {
    return this.getString(this.KeyRole);
  }

  set Role(token: string | undefined) {
    this.setString(this.KeyRole, token);
  }

  Clear(): void {
    [
      this.KeyToken,
      this.KeyEmail,
      this.KeyUserName,
      this.KeyUser,
      this.KeyRole,
      this.KeyLeftNav,
    ].forEach((key) => {
      this.delete(key);
    });
  }
}

export const StorageAuth = new StorageAuthImpl();
